import { useEffect } from 'react';
import {
    EventType,
    featureGuideService,
} from '../../../services/feature-guide-service/feature-guide-service';
import { useQuery } from '../../use-query';

export const useFeatureGuideDaosAnalytics = () => {
    const fgId = useQuery().get('fgid');
    const eventType = useQuery().get('eventType');

    useEffect(() => {
        if (fgId && eventType) {
            featureGuideService.callMetrics(fgId, eventType as EventType);
        }
    }, [fgId, eventType]);
};
